import CompactItemInfo from "./component-library239.mjs";
import ExtendedItemInfo from "./component-library240.mjs";
import "./component-library241.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "BundleConfiguratorItem",
  components: { CompactItemInfo, ExtendedItemInfo },
  props: {
    bundleItem: { type: Object, default: () => ({}) },
    isExtended: Boolean
  },
  emits: ["open-bundle-item-config", "select-variant"]
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "item" }, [_c("CompactItemInfo", { attrs: { "name": _vm.bundleItem.family.name, "active-variants": _vm.bundleItem.activeVariants, "is-configurable": _vm.bundleItem.isConfigurable, "position": _vm.bundleItem.position, "is-extended": _vm.isExtended }, on: { "open-bundle-item-config": (args) => _vm.$emit("open-bundle-item-config", args) } }), _c("ExtendedItemInfo", { attrs: { "is-extended": _vm.isExtended, "bundle-item": _vm.bundleItem }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "f5ec1e62",
  null,
  null
);
const BundleConfiguratorItem = __component__.exports;
export {
  BundleConfiguratorItem as default
};
